export default {
	multiTask: {
		app: "Application",
		upgrade: "Upgrade",
		processPid: "pid of the process",
		working: "Working",
		completed: "Completed",
		completedWithError: "Completed with an error",
		infoAboutThisTaskYouCanSeeInStatus: "Information on these tasks can be viewed in the task status, filtering by comment",
		currentPackageComment: "Comment of the current package",
		task: "Task",
		fileSelect: "Select file",
		youRun: "You are running",
		tasks: "tasks",
		successfully: "Successful",
		moreDetails: "More",
		clearResults: "Clear Results",
		clear: "Clear",
		start: "Start",
		noAppsSelectedError: "No application selected",
		enterStartMessage: "Enter a message to start",
		noSuchTasks: "No such tasks",
		tooLongOperation: "Tasks worked for too long, canceling status updates",
		presetElementNotFound: "One of the preset elements not found",
		enter: "Enter",
		cancellation: "Cancel",
		busyTasks: "Busy tasks"
	},
	runTask: {
		fileSelect: "Select file",
		result: "Result",
		forMoreDetailsAboutValueLookConsole: "For more information on the returned value, see the console",
		cancel: "Cancel",
		exit: "Exit",
		server: "Server",
		app: "Application",
		autoLoading: "Auto-loading",
		administration: "Administration",
		appliedTasks: "Applied Tasks",
		itsMistake: "This is a mistake",
		shortMessage: "short message",
		plsRefreshPage: "Please refresh the page"
	}
}